import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TruncateWithTooltip = ({ text, maxLength = 15, place }) => {
    if (!text) return "";

    const isTruncated = text.length > maxLength;
    const displayText = isTruncated ? text.substring(0, maxLength) + "..." : text;

    return isTruncated ? (
        <OverlayTrigger
            placement={place}
            overlay={<Tooltip>{text}</Tooltip>}
            trigger={['hover', 'click']}
        >
            <span>{displayText}</span>
        </OverlayTrigger>
    ) : (
        displayText
    );
};

export default TruncateWithTooltip;